import { render, staticRenderFns } from "./SingleSection.vue?vue&type=template&id=4e527793&"
import script from "./SingleSection.vue?vue&type=script&lang=js&"
export * from "./SingleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports